import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { UserService } from '@/services';
import type { CurrentUser } from '@/types';

export function useCurrentUser(loggedin: boolean) {
  return useQuery({
    queryKey: ['currentUser'],
    queryFn: async () => {
      const user = await UserService.getMe();
      return user;
    },
    enabled: loggedin,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (userData: Partial<CurrentUser>) => {
      return UserService.updateMe(userData);
    },
    onSuccess: (updatedUser) => {
      queryClient.setQueryData<CurrentUser>(['currentUser'], updatedUser);
    },
  });
}
